import { compose } from 'redux';

// forked applyMiddleware from redux
// it uses full store instead of {getState, dispatch} interface
function applyMiddleware(...middlewares) {
  return (createStore) =>
    (...args) => {
      const store = createStore(...args);
      let dispatch = (..._: any[]) => {
        throw new Error(
          'Dispatching while constructing your middleware is not allowed. ' +
            'Other middleware would not be applied to this dispatch.',
        );
      };

      const middlewareAPI = {
        ...store,
        dispatch: (...params) => dispatch(...params),
      };
      const chain = middlewares.map((middleware) => middleware(middlewareAPI));

      // @ts-ignore
      dispatch = compose(...chain)(store.dispatch);

      return { ...store, dispatch };
    };
}

export default applyMiddleware;
